// extracted by mini-css-extract-plugin
export var addressFields = "_pt-0";
export var animationContainer = "_pt-1";
export var footer = "_pt-2";
export var lineItems = "_pt-3";
export var modalContent = "_pt-4";
export var orderName = "_pt-5";
export var strong = "_pt-6";
export var warning = "_pt-7";